/**
 * Utility function to dynamically import a markdown file
 * @param path Path to the markdown file relative to the public directory
 * @returns Promise that resolves to the markdown content
 */
export const importMarkdown = async (path: string): Promise<string> => {
  try {
    // For production, make sure path starts with a / for absolute path from public directory
    const publicPath = path.startsWith('/') ? path : `/${path}`;
    const response = await fetch(publicPath);
    
    if (!response.ok) {
      throw new Error(`Failed to load markdown file: ${response.status} ${response.statusText}`);
    }
    
    return await response.text();
  } catch (error) {
    console.error('Error loading markdown:', error);
    return '# Error Loading Content\nUnable to load the requested content.';
  }
};
